export default {
  funnel_register_funnel: 'Register Funnel',
  funnel_register_funnel_casual: 'IAA Funnel',
  funnel_register_funnel_pc: 'Register Funnel PC',
  funnel_register_funnel_steam: 'Register Funnel Steam',
  funnel_register_funnel_epic: 'Register Funnel Epic',
  funnel_register_funnel_ps: 'Register Funnel PS',
  funnel_register_funnel_xbox: 'Register Funnel Xbox',
  funnel_device_conversion: 'Device Conversion%',
  funnel_lost: 'Lost',
  funnel_funnel: 'Funnel',
  funnel_step: 'Step',
  funnel_inevitable_step: 'inevitable step',
  funnel_avg_time: 'AVG Time(s)',
  funnel_trends_by_step: 'Trends by step',
  funnel_trends: 'Trends',
  funnel_overall_performance: 'Overall Performance',
  funnel_app_launch: 'App Launch',
  funnel_finish_user_agreement: 'Finish UserAgreement',
  funnel_complete_updates: 'Complete Updates',
  funnel_confirm_login_channel: 'Confirm Login Channel',
  funnel_channel_auth_success: 'Channel Auth Success',
  funnel_register_success: 'Register Success',
  funnel_show_enter_game: 'Show EnterGame',
  funnel_click_into_game: 'Click Into Game',
  funnel_enter_lobby_success: 'Enter Lobby Success',
  funnel_by_app_version: 'By APP Version',
  funnel_by_network_type: 'By Network Type',
  funnel_by_memory: 'By Memory',
  funnel_by_store_channel: 'By Store Channel',
  funnel_by_version: 'By Version',
  funnel_version: 'Version',
  funnel_by_game_stage: 'By Game Stage',
  funnel_game_stage: 'Game Stage',
  funnel_by_character_class: 'By Class',
  funnel_character_class: 'Class',
  funnel_by_user_type: 'By User Type',
  funnel_user_type: 'User Type',
  funnel_conversion: 'Conversion%',
  funnel_count: 'Count',
  funnel_lost_percent: 'Lost%',
  funnel_device_count_conversion: 'Device Count & Conversion%',
  funnel_total: 'Total',

  funnel_funnel_expresion: 'Note: Since the number of new users in "Overview - Daily" is defined as the user who logs in to the lobby game for the first time, and there is a certain loss in the link between Register Success and Enter Lobby Success, the number of Register Success on this page is slightly different from the number of new users in "Overview - Daily".',
  funnel_funnel_app_version_expresion: "Player's  App version",
  funnel_funnel_memory_expresion: "Player's  device memory",
  funnel_funnel_store_channel_expresion: "Store channels for player downloads",
  funnel_funnel_language_expresion: "Player register system language",
  funnel_funnel_network_expresion: "Player's system network type",
  funnel_funnel_app_version_all: "Display data results based on de-duplicated users for all app version",
  funnel_funnel_memory_all_expresion: "Display data results based on de-duplicated users for all memory",
  funnel_filter_tips: "Player's {name}",

};